var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"start"}},[_c('div',[_c('img',{staticClass:"start-img",attrs:{"src":require("./start/assets/Memory.jpg")}}),_vm._v(" "),_c('div',{staticClass:"overlay text-white"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])]),_vm._v(" "),_c('futureIT',{attrs:{"language":_vm.language}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-081254fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Start.vue
// module id = null
// module chunks = 